<template>
  <div v-if="loaded" class="w100" style="margin-bottom: 2rem;">
    <div layout="row center-left" class="w100 headline">
      <div><img class="icon" src="/static/images/instagram-icon.png" srcset="/static/images/instagram-icon@2x.png"></div>
      <div>{{label}}</div>
    </div>
    <div v-for="row in posts">
      <div layout="row sm-column top-stretch">
        <div v-for="post in row">
          <instagram-post :postData="post" :placeholder="getPlaceholder()"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import BackendProxy from '@/BackendProxy';
  import InstagramPost from "./InstagramPost";

  export default {
    components: {InstagramPost},
    name: "instragram-grid",
    props: ['city'],
    data() {
      return {
        loaded: false,
        posts: [],
        label: ''
      }
    },
    created() {
      this._placeholders = BackendProxy.instance.getInstagramPlaceHolders();
      this._index = 0;
    },
    methods: {
      getPlaceholder() {
        if (this._index >= this._placeholders.length) this._index = 0;
        return this._placeholders[this._index++];
      }
    },
    mounted() {
      const cityData = BackendProxy.instance.getCityData(this.city);
      let tag;
      if (this.city == 'home') {
        tag = BackendProxy.instance.instagramUser;
        this.label = '@' + tag;
      } else {
        tag = BackendProxy.instance.instagramTagPrefix + '_' + cityData.name.toLowerCase();
        this.label = '#' + tag ;
      }
      BackendProxy.instance.getInstagramPosts(tag)
      // BackendProxy.instance.getInstagramPosts('bma1234567890')
      // BackendProxy.instance.getInstagramPosts('cars')
        .then((posts) => {
          this.posts[0] = posts.slice(0, 4);
          this.posts[1] = posts.slice(4, 8);
          this.posts[2] = posts.slice(8, 12);
          this.loaded = true;

        })
        .catch(e => {

        });
    }
  }
</script>

<style lang="scss" scoped>
  .headline {
    margin-bottom: 1rem;
    font-size: 1.6rem;
    font-weight: 400;
    @media screen and (max-width: 500px) {
      font-size: 1.5rem;
    }

    /*@media screen and (max-width: 400px) {*/
      /*font-size: 1.3rem;*/
    /*}*/

    /*@media screen and (max-width: 320px) {*/
      /*font-size: 1.3rem;*/
    /*}*/
  }

  .icon {
    width: 40px;
    margin-right: 15px;
    @media screen and (max-width: 500px) {
      width: 25px;
      margin-right: 5px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/blocks/InstragramGrid.vue